import { createSlice } from '@reduxjs/toolkit';



const initialState = {
    storeData: [],
    mirrorData: [],
}

const storeMirrorSlice = createSlice({
    name: 'storeMirror',
    initialState,
    reducers: {
        setStoreData: (state, action) => {
            state.storeData = action.payload;
        },
        setMirrorData: (state, action) => {
            state.mirrorData = action.payload;
        },
    },
});

export const { setMirrorData, setStoreData } = storeMirrorSlice.actions;
export default storeMirrorSlice.reducer;